module.exports = __webpack_public_path__ + "img/edit-map-off.d3da093a.png";